import {
    Empty,
    Select
} from "antd";

import {
    Link
} from "react-router-dom";

import {
    useEffect,
    useState
} from "react";

import {
    BookOutlined,
    ReadOutlined,
    AppstoreOutlined
} from "@ant-design/icons";

import {
    getListCategoryChild
} from "../../api/myBook";


const getImage = productImage => {

    try {

        const images =
            JSON.parse(
                productImage || "[]"
            );

        return (
            images?.find(
                item =>
                    item?.type === "image"
            )?.data || ""
        );

    } catch (error) {

        return "";
    }
};


export default function MyBook({
    book,
    pagination,
    setPagination,
    setCategoryChildId
}) {


    const [bookCategory, setBookCategory] =
        useState([]);


    useEffect(() => {

        getListCategoryChild(
            setBookCategory
        );

    }, []);


    const books =
        book?.data || [];


    const total =
        Number(
            book?.total || 0
        );


    const changeCategory = value => {

        setCategoryChildId(
            value || 0
        );

        setPagination({
            ...pagination,
            page: 1
        });
    };


    return (

        <div
            className="
                bg-[#f7f8fa]

                min-h-[600px]

                rounded-2xl

                overflow-hidden
            "
        >

            {/* HEADER */}

            <div
                className="
                    bg-white

                    px-4
                    py-5

                    md:px-7
                    md:py-6

                    border-b
                    border-gray-100
                "
            >

                <div
                    className="
                        flex
                        flex-col

                        md:flex-row
                        md:items-center
                        md:justify-between

                        gap-4
                    "
                >

                    <div
                        className="
                            flex
                            items-center

                            gap-3
                        "
                    >

                        <div
                            className="
                                w-11
                                h-11

                                md:w-12
                                md:h-12

                                rounded-xl

                                bg-blue-50

                                text-blue-600

                                flex
                                items-center
                                justify-center

                                text-xl
                            "
                        >
                            <BookOutlined />
                        </div>


                        <div>

                            <h1
                                className="
                                    m-0

                                    text-[20px]
                                    md:text-[24px]

                                    leading-tight

                                    font-bold

                                    text-gray-900
                                "
                            >
                                Thư viện của tôi
                            </h1>


                            <p
                                className="
                                    m-0
                                    mt-1

                                    text-[12px]
                                    md:text-[13px]

                                    text-gray-500
                                "
                            >
                                {total > 0
                                    ? `${total} sách trong thư viện`
                                    : "Những cuốn sách bạn đã sở hữu"}
                            </p>

                        </div>

                    </div>


                    <div
                        className="
                            w-full
                            md:w-[250px]
                        "
                    >

                        <Select
                            allowClear
                            showSearch

                            className="w-full"

                            size="large"

                            placeholder="Tất cả danh mục"

                            optionFilterProp="label"

                            filterOption={
                                (
                                    input,
                                    option
                                ) =>
                                    String(
                                        option?.label || ""
                                    )
                                        .toLowerCase()
                                        .includes(
                                            input.toLowerCase()
                                        )
                            }

                            onChange={
                                changeCategory
                            }

                            options={
                                bookCategory?.map(
                                    value => ({
                                        value:
                                            value.category_child_id,

                                        label:
                                            value.category_child_name
                                    })
                                )
                            }
                        />

                    </div>

                </div>

            </div>


            {/* CONTENT */}

            <div
                className="
                    p-3

                    sm:p-4
                    md:p-6
                "
            >

                {books.length > 0 ? (

                    <>

                        <div
                            className="
                                grid

                                grid-cols-2

                                sm:grid-cols-3

                                lg:grid-cols-4

                                2xl:grid-cols-5

                                gap-3
                                sm:gap-4
                                md:gap-5
                            "
                        >

                            {books.map(
                                item => {

                                    const cover =
                                        getImage(
                                            item?.product_image
                                        );


                                    return (

                                        <Link
                                            key={
                                                item?.product_id ||
                                                item?.product_slug
                                            }

                                            to={`/sach-cua-toi/${item?.product_slug}`}

                                            className="
                                                group

                                                block

                                                bg-white

                                                rounded-xl

                                                overflow-hidden

                                                border
                                                border-gray-200

                                                shadow-sm

                                                hover:shadow-lg
                                                hover:border-blue-200

                                                transition-all
                                                duration-200
                                            "
                                        >

                                            <div
                                                className="
                                                    relative

                                                    bg-gray-100

                                                    aspect-[3/4]

                                                    overflow-hidden
                                                "
                                            >

                                                {cover ? (

                                                    <img
                                                        src={cover}

                                                        alt={
                                                            item?.product_name ||
                                                            "Bìa sách"
                                                        }

                                                        loading="lazy"

                                                        className="
                                                            w-full
                                                            h-full

                                                            object-cover

                                                            group-hover:scale-[1.025]

                                                            transition-transform
                                                            duration-300
                                                        "
                                                    />

                                                ) : (

                                                    <div
                                                        className="
                                                            absolute
                                                            inset-0

                                                            flex
                                                            flex-col
                                                            items-center
                                                            justify-center

                                                            gap-2

                                                            text-gray-400
                                                        "
                                                    >

                                                        <BookOutlined
                                                            className="
                                                                text-3xl
                                                            "
                                                        />

                                                        <span
                                                            className="
                                                                text-xs
                                                            "
                                                        >
                                                            Sách điện tử
                                                        </span>

                                                    </div>

                                                )}


                                                <div
                                                    className="
                                                        absolute

                                                        top-2
                                                        left-2

                                                        px-2
                                                        py-1

                                                        rounded-md

                                                        bg-black/60

                                                        text-white

                                                        text-[10px]
                                                        md:text-[11px]

                                                        backdrop-blur-sm
                                                    "
                                                >
                                                    Đã sở hữu
                                                </div>

                                            </div>


                                            <div
                                                className="
                                                    p-3
                                                    md:p-4
                                                "
                                            >

                                                <h3
                                                    className="
                                                        m-0

                                                        text-[13px]
                                                        md:text-[15px]

                                                        leading-[1.45]

                                                        font-semibold

                                                        text-gray-900

                                                        line-clamp-2

                                                        min-h-[38px]
                                                        md:min-h-[44px]

                                                        group-hover:text-blue-600

                                                        transition-colors
                                                    "
                                                >
                                                    {item?.product_name}
                                                </h3>


                                                {item?.product_time && (

                                                    <div
                                                        className="
                                                            mt-2

                                                            text-[11px]
                                                            md:text-xs

                                                            text-gray-500

                                                            truncate
                                                        "
                                                    >
                                                        {item.product_time}
                                                    </div>

                                                )}


                                                <div
                                                    className="
                                                        mt-3

                                                        h-9

                                                        rounded-lg

                                                        bg-blue-50

                                                        text-blue-600

                                                        flex
                                                        items-center
                                                        justify-center

                                                        gap-2

                                                        text-xs
                                                        md:text-sm

                                                        font-semibold

                                                        group-hover:bg-blue-600
                                                        group-hover:text-white

                                                        transition-colors
                                                    "
                                                >

                                                    <ReadOutlined />

                                                    Đọc sách

                                                </div>

                                            </div>

                                        </Link>

                                    );
                                }
                            )}

                        </div>


                        {total > books.length && (

                            <div
                                className="
                                    mt-8
                                    pb-2

                                    flex
                                    justify-center
                                "
                            >

                                <button
                                    type="button"

                                    onClick={() => {

                                        setPagination({
                                            page: 1,
                                            pageSize:
                                                pagination.pageSize + 6
                                        });
                                    }}

                                    className="
                                        min-w-[150px]

                                        h-11

                                        px-6

                                        rounded-xl

                                        border
                                        border-blue-200

                                        bg-white

                                        text-blue-600

                                        text-sm
                                        font-semibold

                                        shadow-sm

                                        hover:bg-blue-600
                                        hover:text-white
                                        hover:border-blue-600

                                        transition-all
                                    "
                                >
                                    Xem thêm
                                </button>

                            </div>

                        )}

                    </>

                ) : (

                    <div
                        className="
                            min-h-[420px]

                            bg-white

                            rounded-xl

                            flex
                            flex-col
                            items-center
                            justify-center

                            px-4
                        "
                    >

                        <div
                            className="
                                w-16
                                h-16

                                mb-4

                                rounded-full

                                bg-gray-100

                                flex
                                items-center
                                justify-center

                                text-2xl
                                text-gray-400
                            "
                        >
                            <AppstoreOutlined />
                        </div>


                        <Empty
                            image={
                                Empty.PRESENTED_IMAGE_SIMPLE
                            }

                            description={
                                <span
                                    className="
                                        text-gray-500
                                    "
                                >
                                    Chưa có sách trong danh mục này
                                </span>
                            }
                        />

                    </div>

                )}

            </div>

        </div>

    );
}
